// extracted by mini-css-extract-plugin
module.exports = {"container":"AboutMePage_container__2wIZC","title":"AboutMePage_title__2V11X"};